<template>
  <session-button
    :icon-name="isSharingScreen ? 'screenShareOffM' : 'screenShareM'"
    :is-active="isSharingScreen!"
    data-test="screen-sharing-button"
    :title="isSharingScreen ? $t('calls.endScreenSharing') + ' (' + $t('keys.S') + ')' : $t('calls.startScreenSharing') + ' (' + $t('keys.S') + ')'"
    @click="toggle"
  />
</template>
<script lang="ts" setup>
import { SessionButton } from '@/shared/components/buttons'

import { useToggleScreenSharing } from '../lib'

defineProps<{
  sessionId: string,
}>()

const { isSharingScreen, toggle } = useToggleScreenSharing()
</script>
